import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionEntityListSingleReport  {
    _originalTypeClassName = "zERP.BO.TransactionEntityListSingleReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionEntityListSingleReport.translate = translateService;
}
this.TransactionEntity = new Domain.TransactionEntity();
this.GroupBy = null;
this.PreviousCharge = null;
this.PreviousCredit = null;
this.CurrentCharge = null;
this.CurrentCredit = null;
this.CumulativeCharge = null;
this.CumulativeCredit = null;
this.Remaining = null;
this.TransactionEntityListSingleReportKey = null;
this._key = this.TransactionEntityListSingleReportKey = 0; 
}

static translate: TranslateService;
_key: any;
GroupBy:any;
PreviousCharge:any;
PreviousCredit:any;
CurrentCharge:any;
CurrentCredit:any;
CumulativeCharge:any;
CumulativeCredit:any;
Remaining:any;
TransactionEntity:any;
private _TransactionEntityListSingleReportKey:any;
get TransactionEntityListSingleReportKey(): any {
    return this._TransactionEntityListSingleReportKey;
  }
set TransactionEntityListSingleReportKey(value: any) {
    this._TransactionEntityListSingleReportKey = value;
    this._key = value;
  }
static setTransactionEntity = ($this, value) => {
var oldValue = $this.TransactionEntity;
$this.TransactionEntity = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TransactionEntityListSingleReportKey == null || $this.TransactionEntityListSingleReportKey == 0;
            }


}